export const CONVENTION_LIST = 'CONVENTION_LIST';
export const CONVENTION_LOADER = 'CONVENTION_LOADER';
export const CONVENTION_EDIT='CONVENTION_EDIT';